// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".instant-add-grid{background-image:repeating-linear-gradient(0deg,transparent,transparent 70px,#ccc 0,#ccc 71px),repeating-linear-gradient(-90deg,transparent,transparent 70px,#ccc 0,#ccc 71px)}", ""]);
// Exports
module.exports = exports;
